module.exports = __webpack_public_path__ + "static/media/8OLA19.19556ae5.jpg";